'use strict';

import React, { Component } from 'react'

import Button from '@material-ui/core/Button'

import SearchIcon from '@/Icons/Search'

const { app } = window;

export default class GlobalSearch extends Component
{
	openSearch = (e) =>
	{
		app.emit('open__GlobalSearchResults');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const output =
		(
			<div className="c-searchbar c-searchbar--global">

				<div className="c-searchbar__visual-input"
					onClick={ component.openSearch }
				/>

				<Button className="c-searchbar__open"
					onClick={ component.openSearch }>
					<SearchIcon className="c-searchbar__open-icon" />
				</Button>

			</div>
		);

		return output;
	}
}